import { Component, OnInit } from '@angular/core';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';

@Component({
  selector: 'jhi-warning-page',
  templateUrl: './warning-page.component.html',
  styleUrls: ['./warning-page.component.scss']
})
export class WarningPageComponent implements OnInit {

  eAppRegConst = BUSINESS_REG_APP_CONSTANT
  startPage = ""
  constructor() {
    // empty method
   }

  ngOnInit(): void {
    this.startPage =  this.eAppRegConst.StartPage
  }

}
